/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Retry_ButtonInputs */

const en_matching_score_retry_button = /** @type {(inputs: Matching_Score_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const de_matching_score_retry_button = /** @type {(inputs: Matching_Score_Retry_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Matching_Score_Retry_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_retry_button = /** @type {((inputs?: Matching_Score_Retry_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Retry_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_retry_button(inputs)
	return en_matching_score_retry_button(inputs)
});